module.exports = __webpack_public_path__ + "img/line_2.16bb0d32.png";